<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>音视频课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/courseList')">课程列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='课程标题'>
            <el-input
              style="width:200px"
              v-model="filters.keywords"
              placeholder="请输入标题内容"
            >
            </el-input>
          </el-form-item>
          <el-form-item label='课程内容'>
            <el-input
              style="width:200px"
              v-model="filters.good_key"
              placeholder="请输入课程内容"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('90012991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>

          </el-form-item>

          <div>
            <el-form-item label="素材类型">
            <el-select
              v-model="filters.reco_type"
              clearable
            >
              <el-option
                v-for="option in outTOptions"
                :value="option.id"
                :key="option.id"
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上架类型">
            <el-select
              v-model="filters.recommend"
              clearable
            >
              <el-option
                label="上架中"
                value="2"
              ></el-option>
              <el-option
                label="下架中"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          </div>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="title"
            label="标题"
          >
          </el-table-column>

          <el-table-column label="列表图片">
            <template slot-scope="scope">
              <img
                v-show="scope.row.list_pic != null && scope.row.list_pic != ''"
                :src="scope.row.list_pic"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>

          <el-table-column prop="work_type" label="价值观">

          </el-table-column>

          <el-table-column
            prop="info_type"
            label="素材类型"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.info_type == 1"
                type="success"
                disable-transitions
              >图文</el-tag>
              <el-tag
                v-if="scope.row.info_type == 2"
                disable-transitions
              >音频</el-tag>
              <el-tag
                v-if="scope.row.info_type == 3"
                type="info"
                disable-transitions
              >视频</el-tag>

              <el-tag
                v-if="scope.row.info_type == 4"
                type="info"
                disable-transitions
              >打卡文章</el-tag>
              <el-tag
                v-if="scope.row.info_type == 5"
                type="info"
                disable-transitions
              >帮助文档</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >是</el-tag>
              <el-tag
                v-if="scope.row.status != 2"
                type="info"
                disable-transitions
              >否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="hasPower('90012991') && scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >上架</el-button>
              </template>
              <template v-if="hasPower('90012991') && scope.row.status == 2">
                <el-button
                  @click="upHouseStatus(scope.row,1)"
                  type="text"
                  size="small"
                >下架</el-button>
              </template>
              <el-button
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >查看详情</el-button>
              <el-button v-if="hasPower('90012991')"
                @click="upHouseStatus(scope.row,3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="查看评论图片"
      :visible.sync="dialogAddVisible"
      width="30%"
    >
      <div class="shop-pic">
        <img v-for="item in picList" :key="item" :src="item"/>

      </div>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {
  },
  data() {
    return {
      picList:[],
      dialogAddVisible:false,
      filters: {
        recommend:null,
        keywords: null,
        reco_type: null,
        good_key:null
      },
      page_num: 1,
      outTOptions:[],
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    var that = this;
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    let params1 = {
      pageNum: 1,
      pageSize: 100,
      infoType: 8,
      noVip:1,
      token: localStorage.getItem("api_token")
    };
    API.good_first_type_list(params1)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.outTOptions = [];
            for (var i = 0; i < result.result.list.length; i++) {
              if (result.result.list[i].title != "全部") {
                that.outTOptions.push(result.result.list[i]);
              }
              
            }
            that.outTOptions.push({
                id:4,
                title:'打卡文章'
              });
              that.outTOptions.push({
                id:5,
                title:'帮助文档'
              });
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    this.handleSearch();
  },
  methods: {
     addPostDialog() {
      this.$router.push({
        path: "/addCourse"
      });
    },
    editPostDialog(row) {
      this.$router.push({
        path: "/addCourse",
        query: {
          good: row
        }
      });
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定删除该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: 2
            };
            API.del_course(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定下架该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.down_course(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "下架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2){
        let that = this;
        this.$confirm("确定上架该素材吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.push_course(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "上架成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    showSecond(row){
      this.picList = row.content.split(',');
      console.info(this.picList);
      this.dialogAddVisible = true;
    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.reco_type) {
        params.reco_type = that.filters.reco_type;
      }
      if (that.filters.keywords) {
        params.keywords = that.filters.keywords;
      }
      if (that.filters.good_key) {
        params.good_key = that.filters.good_key;
      }
      if (that.filters.recommend) {
        params.recommend = that.filters.recommend;
      }

      that.loading = true;
      API.course_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic{
    width: 100%;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
    height: 80vh;
    overflow: hidden;
    overflow-y: auto;
}
.shop-pic img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/courseList.vue